import _axios from "axios";

const axios = _axios

axios.create({
    timeout: 10000,
    headers: {
        get: {
            "Accept": "application/json"
        },
    }
});

export default {
    get(params) {
        return axios.get("https://zipcloud.ibsnet.co.jp/api/search", {params})
    }
}